// extracted by mini-css-extract-plugin
export default {"mainNav":"MainNav_mainNav__0LxMf","mainNavLogo":"MainNav_mainNavLogo__UT5Te","mainNavLogoContent":"MainNav_mainNavLogoContent__nUZXn"};